module.exports = __webpack_public_path__ + "img/Q3.c95ed1d3.jpg";